import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { TrainingRepository } from "../../modules/vacancyApplication/vacancyProfessionalDevelopment/TrainingRepository";
import filesize from "filesize";
import FileIcon, { defaultStyles } from "react-file-icon";
import { VacancyAppRepository } from "../../modules/vacancyApplication/VacancyAppRepository";
import { SETTINGS } from "../../properties/ApiProps";
import { LOCALE } from "../../properties/Locale";
import { AuthService } from "../../auth/AuthService";

export default function Upload(props) {
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const [rerender, triggerRerender] = React.useState(false);

  useEffect(() => {
    if (props.attachments) {
      setAttachments(props.attachments);
    }
  }, [props.attachments]);

  const handleDialogClose = () => {
    setOpenDialog(false);
    if (props.onClose) props.onClose();
    if (props.onComponentClose)
      props.onComponentClose(props.rowIndex, attachments);
  };

  const handleChangeFile = (files) => {
    setFiles(files);
    TrainingRepository.uploadFile(
      props.vacancyAppId,
      props.vacancyAppDomain,
      files[files.length - 1]
    ).then(
      (res) => {
        let tempAttachments = attachments;
        tempAttachments.push(res.data);
        setAttachments(tempAttachments);
        triggerRerender(!rerender);
      },
      (err) => {}
    );
  };

  const deleteFile = (id, index) => {
    let data = attachments;
    TrainingRepository.deleteFile(id).then((res) => {
      data.splice(index, 1);
      setAttachments(data);
      triggerRerender(!rerender);
    });
  };

  return (
    <div>
      <label htmlFor="proofs-button-file">
        <Button
          variant="contained"
          component="span"
          color="default"
          size="small"
          onClick={() => setOpenDialog(!openDialog)}
        >
          {!props.disabled ? <Icon>backup</Icon> : <Icon>cloud_download</Icon>}{" "}
          ({attachments ? attachments.length : 0})
        </Button>
      </label>

      <Dialog
        open={openDialog}
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: {
            overflowY: "unset",
          },
        }}
      >
        <DialogTitle>
          <IconButton
            style={{ float: "right" }}
            aria-label="close"
            onClick={() => handleDialogClose()}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {!props.disabled && (
            <DropzoneArea
              multiple={false}
              onChange={(files) => handleChangeFile(files)}
              previewChipProps={false}
              showFileNamesInPreview={false}
              showPreviews={false}
              showPreviewsInDropzone={false}
              filesLimit={10}
              dropzoneText={LOCALE.dropzoneText}
              acceptedFiles={[".pdf", ".docx", ".xls", ".xlsx", ".rar", ".zip"]}
            ></DropzoneArea>
          )}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{LOCALE.fileType}</TableCell>
                <TableCell>{LOCALE.fileName}</TableCell>
                <TableCell>{LOCALE.fileSize}</TableCell>
                <TableCell style={{ width: "100px" }}>
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {attachments &&
                attachments.map((attachment, index) => (
                  <TableRow>
                    <TableCell>
                      <FileIcon
                        size={50}
                        extension={attachment.fileExtension}
                        {...defaultStyles[attachment.fileExtension]}
                      />
                    </TableCell>
                    <TableCell>{attachment.filename}</TableCell>
                    <TableCell>{filesize(attachment.fileSize)}</TableCell>
                    <TableCell>
                      <a
                        target="blank"
                        href={`${SETTINGS.API_URL}vacancyApplications/${
                          props.vacancyAppId
                        }/attachments/${attachment.id}?access_token=${
                          AuthService.getToken().access_token
                        }`}
                      >
                        <IconButton
                          size="small"
                          color="secondary"
                          aria-label="Download"
                        >
                          <Icon>cloud_download</Icon>
                        </IconButton>
                      </a>
                      {!props.disabled && (
                        <IconButton
                          size="small"
                          color="secondary"
                          aria-label="delete"
                          onClick={() => deleteFile(attachment.id, index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            style={{ float: "right" }}
            color="secondary"
            onClick={() => handleDialogClose()}
          >
            {LOCALE.close}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
